import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var HideShowPasswordIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 48 48" }),
    React.createElement("g", { fill: "currentColor", stroke: "currentColor", strokeLinecap: "square", strokeWidth: "2" },
        React.createElement("circle", { cx: "23.996", cy: "20", fill: "none", r: "11", stroke: "currentColor" }),
        React.createElement("circle", { cx: "23.996", cy: "20", r: "4", stroke: "none" }),
        React.createElement("circle", { cx: "23.996", cy: "20", fill: "none", r: "4" }),
        React.createElement("path", { d: "M2.4,25.255a2.219,2.219,0,0,1-.006-2.515C4.88,19.13,12.851,9,24,9,35.057,9,43.085,19.115,45.6,22.733a2.217,2.217,0,0,1,0,2.53C43.059,28.876,34.97,39,24,39,12.939,39,4.905,28.861,2.4,25.255Z", fill: "none", stroke: "currentColor" }),
        (props === null || props === void 0 ? void 0 : props.isClicked) && React.createElement("line", { fill: "none", x1: "3", x2: "41", y1: "41", y2: "3" })))); };

export { HideShowPasswordIcon as default };
